import { CurrencyCodes } from '@onevesthq/ov-enums';

const handleUrlWithCurrency = (urlString: string, currencies: string): string => {
  try {
    const url = new URL(urlString);
    if (url.searchParams.has('accountSelectorCurrency')) {
      url.searchParams.set('accountSelectorCurrency', currencies);
    } else {
      url.searchParams.append('accountSelectorCurrency', currencies);
    }
    return url.toString();
  } catch (error) {
    return urlString;
  }
};

export const generateFlinksUrl = (
  externalIframeUrl: string,
  productShelfCurrencies: string[] | undefined,
): string => {
  const currencies = productShelfCurrencies?.length
    ? productShelfCurrencies.map((c) => c.toLowerCase()).join(',')
    : CurrencyCodes.CAD.toLowerCase();

  if (externalIframeUrl) {
    return handleUrlWithCurrency(externalIframeUrl, currencies);
  }

  const defaultUrl = process.env.REACT_APP_FLINKS_URL ?? '';
  if (!defaultUrl) return '';

  return handleUrlWithCurrency(defaultUrl, currencies);
};
